import { render, staticRenderFns } from "./TableOnly.vue?vue&type=template&id=dfcb7aca&scoped=true"
import script from "./TableOnly.vue?vue&type=script&lang=js"
export * from "./TableOnly.vue?vue&type=script&lang=js"
import style0 from "./TableOnly.vue?vue&type=style&index=0&id=dfcb7aca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfcb7aca",
  null
  
)

export default component.exports